import React from "react";
import { useHistory } from "react-router-dom";

import Icon from "../../../../components/Icon/Icon";
import { Layout } from "../../../../components/Layout";
import { ENV } from "../../../../constants/env";

import "./styles.css";
import CloseIcon from '../../../../assets/images/icons/close.svg'
import ReturnIcon from '../../../../assets/images/icons/return.svg'
const BackButton = ({ isMobile }) => {
    const history = useHistory();
    const isAForm = Number(ENV.REACT_APP_IS_A_FORM) === 1;

    const backButton = () => {
        if (!isAForm) {
            return history.goBack();
        }
        window.location.reload();
    };
    return (
        <Layout align="center" className="back-button" onClick={() => backButton()}>
            {isAForm ? (
                <Icon className="backButton--icon" name="close" image={CloseIcon} />
            ) : (
                <Icon className="backButton--icon" name="return" image={ReturnIcon} />
            )}{" "}
            {!isMobile && <span>Regresar</span>}
        </Layout>
    );
};

export default BackButton;
